import * as yup from 'yup';
import { dobValidation, UserFormValues } from '../YourInfo/YourInfo.meta';

export interface PartnerInfoFormValues {
  partner: UserFormValues;
  spouseTaxFilingState: number | null;
}

export const partnerValidation = yup
  .object()
  .when('$showPartnerSection', {
    is: true,
    then: yup.object().shape({
      firstName: yup.string().required('Partner First Name is required.'),

      lastName: yup.string(),

      dob: dobValidation,
    }),
  })
  .nullable();
